module.exports = __webpack_public_path__ + "img/跳蚤市场.4e560e29.png";